import * as yup from 'yup'

import { EMAIL_REGEX } from 'src/constants'

export const RecoverPassSchema = yup.object({
  email: yup
    .string()
    .matches(EMAIL_REGEX, 'invalid-email')
    .required('email-required'),
})

export const RecoverPassCodeSchema = yup.object({
  code: yup.string().required('code-required').min(6, 'code-min-length'),
})

export const ResetPassSchema = yup.object({
  password: yup
    .string()
    .min(8, 'pass-min-8-chars')
    .matches(/[a-z]+/, 'one-lowercase')
    .matches(/[A-Z]+/, 'one-uppercase')
    .matches(/\d+/, 'one-number')
    .matches(/[!@#$%^&*(),.?":{}|<>]+/, 'one-special-char')
    .required('password-required'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), ''], 'password-does-not-match')
    .required('password-confirmation-required'),
})
